import { render } from "./ScreenLoading.vue?vue&type=template&id=a15cdfe6"
import script from "./ScreenLoading.vue?vue&type=script&lang=js"
export * from "./ScreenLoading.vue?vue&type=script&lang=js"

import "./ScreenLoading.vue?vue&type=style&index=0&id=a15cdfe6&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__